function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { HeaderGroupManager } from './header-group';
window.GeoLocation = {
  callGeo: function callGeo() {
    return fetch("https://ip.ecom.umgapps.com/ip/lookup").then(function (response) {
      return response.json();
    });
  },
  geoContent: function geoContent(countryName, countryISOCode) {
    var geoShow = document.querySelectorAll('[data-geo-show]');
    var itemList = '';
    var _iterator = _createForOfIteratorHelper(geoShow),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        itemList = item.dataset.geoShow.split(',');
        if (itemList.includes(countryISOCode)) {
          var _item$parentNode$pare;
          item.classList.add('!block');
          if ((_item$parentNode$pare = item.parentNode.parentNode) !== null && _item$parentNode$pare !== void 0 && _item$parentNode$pare.classList.contains('section-soft-redirects')) {
            var headerGroupManager = HeaderGroupManager.getInstance();
            headerGroupManager.updateMeasurements();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var geoHide = document.querySelectorAll('[data-geo-hide]');
    var _iterator2 = _createForOfIteratorHelper(geoHide),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _item = _step2.value;
        itemList = _item.dataset.geoHide.split(',');
        if (itemList.includes(countryISOCode)) {
          _item.classList.add('!hidden');
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var geoCountryNameReplace = document.querySelectorAll('[data-geo-countryname-replace]');
    var _iterator3 = _createForOfIteratorHelper(geoCountryNameReplace),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _item2 = _step3.value;
        _item2.outerHTML = countryName;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    var geoCountryIsoReplace = document.querySelectorAll('[data-geo-countryiso-replace]');
    var _iterator4 = _createForOfIteratorHelper(geoCountryIsoReplace),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _item3 = _step4.value;
        _item3.outerHTML = countryISOCode;
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    if (document.querySelector('dialog[data-modal="softRedirectPopup"]')) {
      var softRedirectPopup = document.querySelector('dialog[data-modal="softRedirectPopup"]');
      var showPopup = true;
      if (sessionStorage.getItem('_x_softRedirectVisible')) {
        var savedValue = sessionStorage.getItem('_x_softRedirectVisible');
        if (savedValue === 'false') showPopup = false;
      }
      if (showPopup && softRedirectPopup.classList.contains('!block')) softRedirectPopup.showModal();
    }
  },
  applyGeo: function applyGeo(countryName, countryISOCode, city) {
    if (!Shopify.designMode) {
      Shopify.analytics.publish('geolocation_detected', {
        countryCode: countryISOCode,
        city: city
      });
    }
    this.geoContent(countryName, countryISOCode);
    window.countryISOCodeGlobal = countryISOCode;
  },
  checkGeo: function checkGeo() {
    var _this = this;
    this.callGeo().then(function (response) {
      var countryISOCode = response.countryISOCode;
      var countryName = response.country;
      var city = response.city;
      _this.applyGeo(countryName, countryISOCode, city);
    });
  }
};
window.addEventListener('load', function () {
  window.GeoLocation.checkGeo();
});